import { supabase } from './supabase.js';

/**
 * Insert a contact-form enquiry. Works for guests and logged-in users.
 * If the visitor is signed in, `user_id` is attached so admins can link
 * the message back to a profile.
 */
export async function submitMessage({ name, email, phone, topic, message }) {
  const { data: sess } = await supabase.auth.getSession();
  const uid = sess?.session?.user?.id || null;

  const payload = {
    user_id: uid,
    name: String(name || '').trim().slice(0, 200),
    email: (email && String(email).trim().slice(0, 200)) || null,
    phone: (phone && String(phone).trim().slice(0, 40)) || null,
    topic: (topic && String(topic).trim().slice(0, 80)) || null,
    message: String(message || '').trim().slice(0, 5000),
  };

  if (!payload.name || !payload.message) {
    return { error: new Error('Name and message are required.') };
  }

  const { data, error } = await supabase
    .from('messages')
    .insert(payload)
    .select()
    .single();
  return { data, error };
}
